import { Component, OnInit, OnDestroy, OnChanges, SimpleChanges, Input, Injector, HostBinding } from '@angular/core';
import { SemControlComponent } from '../sem-control/sem-control.component';
import { ValueAccessorBase } from '../shared/value-accessor/value-accessor-base';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import * as _ from 'lodash';
import { Subscription } from 'rxjs';
import { SemConfirmDialogComponent } from '../dialogs/sem-confirm-dialog/sem-confirm-dialog.component';
import { SemParameterDialogComponent } from '../dialogs/sem-parameter-dialog/sem-parameter-dialog.component';
import { SemO2mSectionDialogComponent } from '../dialogs/sem-o2m-section-dialog/sem-o2m-section-dialog.component';
import { DialogType } from 'src/app/shared/components/sem-dynamic/sem-dynamic.component';
import { RequestModel } from 'src/app/models/request/request-model';
import { SemDynamicControlComponent } from '../shared/sem-dynamic-control/sem-dynamic-control.component';
import { environment } from '../../../../environments/environment';
import { UserService } from 'src/app/services/user/user-provider.service';

@Component({
    selector: 'sem-one-to-many-container',
    templateUrl: './sem-one-to-many-container.component.html',
    styleUrls: ['./sem-one-to-many-container.component.css'],
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: SemOneToManyContainerComponent, multi: true }
    ],
    standalone: false
})
export class SemOneToManyContainerComponent extends ValueAccessorBase<any> implements OnInit, OnDestroy, OnChanges {

  private subscriptions: Subscription[] = [];

  @Input() bindingPropertyName: any;
  @Input() maxCount: number = -1;
  @Input() sectionTransferUrl: any;
  @Input() sectionContent: any;
  @Input() contentTemplate: any;
  @Input() actions: any = [];
  @Input() overrideActions: any = [];
  @Input() forwardEntities: any = [];
  @Input() forwardEntity: any;
  @Input() postAddNewSectionLogic: string;
  @Input() hideNewAddSection: boolean = false;
  @Input() autoAddSectionIfEmpty: boolean = false;
  @Input() showAsListing: boolean = false;
  @Input() inlineEdit: boolean = false;
  @Input() listingFields: any;
  @Input() projections: any;
  @Input() presentTableLayoutInReadonly: boolean = false;
  @Input() statisticsView: boolean = false;

  @Input() showCustomAdditionalDataFields: boolean = false;
  @Input() hideOneToManyItems: boolean = false;
  @Input() propertyNameAdditionalData: string;
  @Input() hideNewAddSectionCondition: string;
  @Input() hideRepeaterActionsCondition: string;
  // JS logic that will be evaluated after remove section event	
  @Input() afterRemoveSectionLogicEvent: string;
  @Input() customApiAdditionalDataFields: string;
  @Input() additionalFieldHideCondition: string;

  @Input() addNewTranslation: string | null = null;
  @Input() onSearchNavigateUrl: string = "";

  @Input() containerTitle: string = "";
  @Input() hideSectionWhenNotEditing: boolean = false;
  @Input() addNewButtonOnTop: boolean = false;
  @Input() deleteDisabled: boolean = false;
  @Input() jsFilter: any = false;
  @Input() hideEditIcon: boolean = false;
  // inline edit: a click on a row opens enableClickOnRowRedirectUrl + row Id in a new browser tab
  @Input() enableClickOnRow: boolean = false;
  @Input() enableClickOnRowRedirectUrl: string = "";

  @Input() orderEnabled: boolean = false;
  @Input() orderProperty: any = "";
  @Input() jsAddCondition: any = "";
  @Input() uniqueIdentifier: any = "";
  @Input() indexingPrefix: any = "";
  @Input() indexingEnabled: boolean = false;

  /**
   * When set, adding and editing a section happens in a modal dialog instead of
   * inline above the listing. Off by default - every existing form keeps its layout.
   */
  @Input() editInDialog: boolean = false;

  /**
   * Marks the host when the sections are edited in a dialog. The page template keeps a hidden
   * copy of the section controls next to this element (div.o2m-content); the page save uses
   * this marker to leave those controls out of its validity check (see required-fields.ts).
   */
  @HostBinding('attr.data-edit-in-dialog') get editInDialogAttr() {
    return this.editInDialog ? 'true' : null;
  }
  addAllowed: boolean = true;
  nestedRenderUrl: string = "";

  parsedFilterPredicate: (k: any) => boolean;

  currentNumber: number = 0;
  showDD: boolean = false;
  public templateProvided: boolean = false;
  private sectionAdded: boolean = false;

  //Props for listing grid view
  public gridSection: any = null;
  public inEditMode: boolean = false;


  private additionalFields = [];
  // model reference the additional field definitions were last requested for (avoids duplicate requests)
  private additionalFieldsLoadedForModel: any = null;
  private additionalFieldsLoadedForList: any = null;

  // this property stores values true/false for each additionalfield so we know if we hide the field or not
  private additionalFieldsHiding: any = {};

  selectedIndex: number = 0;

  // Row context of the custom action that was last clicked (listing / inline-edit table).
  // Available inside ActionBody, Condition, PreJS and PostJS as this.currentActionSection / this.currentActionIndex.
  currentActionSection: any = null;
  currentActionIndex: number = -1;

  /**
   * Executes a custom row action from the listing / inline-edit table.
   * FormAction (server-registered action + full ActionsService workflow) wins over ActionBody (plain JS eval).
   * Same precedence as OneToManySectionComponent.evaluateSectionAction; the clicked row is sent as the Envelope.
   */
  evaluateRowAction(action: any, section: any, index: number) {
    this.currentActionSection = section;
    this.currentActionIndex = index;

    if (action.FormAction) {
      this.restProviderService.getDataGET("api/actions/" + action.FormAction, "application/json").subscribe((data: any) => {
        let formAction = JSON.parse(data);
        if (formAction == null || typeof formAction == "undefined") {
          return;
        }

        if (formAction.ParameterForm != null && typeof formAction.ParameterForm != "undefined" && formAction.ParameterForm.Id > 0) {
          var reportId = null;
          if (formAction.ParameterForm.Report != null && typeof formAction.ParameterForm.Report != "undefined") {
            reportId = formAction.ParameterForm.Report.Id;
          }

          const dialogRef = this.dialog.open(SemParameterDialogComponent, {
            data: {
              parameterFormId: formAction.ParameterForm.Id,
              reportId: reportId,
              customHeaderTitle: formAction.ParameterForm.CustomHeaderTitle,
              customCssClass: formAction.ParameterForm.CustomCssClass
            }
          });

          dialogRef.afterClosed().subscribe(returnData => {
            // only call action if parameter popup was confirmed (not cancelled - close button)
            if (returnData != null && typeof returnData != "undefined" && returnData.Canceled == false) {
              var inputParametersModel = returnData["Model"];
              this.actionsService.callAction(formAction, section, null, null, this, action.BulkAction, inputParametersModel, formAction.OnlyClientLogic, false, action.BulkExport, formAction.SkipBulkActionApiMethod);
            }
          });
        } else {
          // just call action without parameters form popup
          this.actionsService.callAction(formAction, section, null, null, this, action.BulkAction, null, formAction.OnlyClientLogic, false, action.BulkExport, formAction.SkipBulkActionApiMethod);
        }
      }, error => {
        console.log(error);
      });
    } else if (action.ActionBody) {
      this.evaluateAction(action.ActionBody);
    }
  }

  typeoflisting() {
    return typeof (this.showAsListing);
  }
  typeofinline() {
    return typeof (this.inlineEdit);
  }
  typeofwt() {
    return typeof (this.hideNewAddSection);
  } super() { }

  ngOnInit() {
    this.updateReadOnlyFromCondition();
  }

  // readOnlyCondition is evaluated by SemControlComponent.evaluateReadOnlyCondition (record model in
  // scope, never throws). On init the record is usually not loaded yet, so it is evaluated again when
  // [model] or the condition changes.
  private updateReadOnlyFromCondition() {
    if (typeof this.readOnlyCondition != "string" || this.readOnlyCondition.length == 0
      || this.model == null || typeof this.model == "undefined") {
      return;
    }
    this.isReadOnly = this.evaluateReadOnlyCondition() == true;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.model || changes.readOnlyCondition) {
      this.updateReadOnlyFromCondition();
    }
    // sem-dynamic assigns the freshly loaded model (new object reference) and fires
    // restProviderService._modelValueChanged synchronously - before change detection has
    // pushed that new reference into our [model] input. The subscription handler therefore
    // runs against the old (empty) model, finds no additional data field definitions and
    // never requests them. Re-run the additional data logic once the input actually changes.
    if (changes.model && !changes.model.firstChange && this.model != null && typeof this.model != "undefined") {
      this.parseAdditionalDataJson();
      this.loadAdditionalFieldsForModel(this.dfms.getValue(this.model, this.bindingPropertyName));
    }
  }

  // need to convert additionalfields json string to json object for mapping features
  // in presubmit event we convert back to string json (stringify)
  private parseAdditionalDataJson() {
    if (this.model != null
      && typeof this.model != "undefined"
      && this.propertyNameAdditionalData != null
      && typeof this.propertyNameAdditionalData != "undefined"
      && this.propertyNameAdditionalData.length > 0) {
      if (this.model[this.propertyNameAdditionalData] != null && typeof this.model[this.propertyNameAdditionalData] != "undefined") {
        // only parse if it's not already parsed into object
        // so only if json string
        if (typeof this.model[this.propertyNameAdditionalData] === "string") {
          try {
            this.model[this.propertyNameAdditionalData] = JSON.parse(this.model[this.propertyNameAdditionalData]);
          } catch {
            this.model[this.propertyNameAdditionalData] = {};
          }
        }
      }
    }
  }

  // requests additional field definitions once per model instance
  private loadAdditionalFieldsForModel(listOfAdditionalData) {
    if (this.showCustomAdditionalDataFields != true) {
      return;
    }
    if (typeof listOfAdditionalData != "undefined" && listOfAdditionalData != null && listOfAdditionalData.length > 0) {
      // skip only the exact repeat (same model, same definitions list) - e.g. ngOnChanges + subscription for one load
      if (this.additionalFieldsLoadedForModel === this.model && this.additionalFieldsLoadedForList === listOfAdditionalData) {
        return;
      }
      this.additionalFieldsLoadedForModel = this.model;
      this.additionalFieldsLoadedForList = listOfAdditionalData;
      this.loadAdditionalFields(listOfAdditionalData);
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
    this.subscriptions = [];
  }

  ngAfterContentInit() {
    this.getContentTemplate();
    if (this.presentTableLayoutInReadonly == true) {
      this.selectedIndex = -1;
    }

    if (this.jsFilter) {
      this.parsedFilterPredicate = ((k: any) => {
        return new Function('k', `return ${this.jsFilter}`)(k);
      }) as (k: any) => boolean;

    }

    this.subscriptions.push(
      this.restProviderService.modelValueChanged.subscribe(model => {

        this.parseAdditionalDataJson();

        let toAssign = this.dfms.getValue(this.model, this.bindingPropertyName);


        if (this.autoAddSectionIfEmpty && !this.showAsListing) {
          if (this.sectionAdded == false || model["LOADEDFROMAPI"]) {
            // if empty
            if (typeof toAssign == "undefined" || toAssign == null || toAssign.length == 0) {
              this.sectionAdded = true;
              this.addSection();
            }
          }
        }

        if (this.showAsListing) {
          if (typeof toAssign != "undefined") {
            if (toAssign.length > 0) {
              this.inEditSection(toAssign.length - 1);
              this.changeDetection.detectChanges();
            }
          }
        }

        this.loadAdditionalFieldsForModel(toAssign);

        if (typeof (this.inlineEdit) != "undefined" && (this.inlineEdit == true)) {
          this.gridSection = null;
          this.inEditMode = false;
        }

        // Ensure CD runs for dynamically compiled one-to-many sections
        try { this.changeDetection.detectChanges(); } catch (e) {}

      })
    );

    this.subscriptions.push(
      this.dfms._modelMTOValueChanged.subscribe(model => {

        if (this.propertyNameAdditionalData != null
          && typeof this.propertyNameAdditionalData != "undefined"
          && this.propertyNameAdditionalData.length > 0) {

          this.parseAdditionalDataJson();

        } else {
          // bind to global model in case we need this in section
          // for example we have dropdown in section which we want to filter based on some value on form - we cannot acces this value through this.model
          // baucse each section has it's own model, so we need to go via globalModel
          this.dfms.globalModel = model;
        }

        if (typeof (this.inlineEdit) != "undefined" && (this.inlineEdit == true)) {
          this.gridSection = null;
          this.inEditMode = false;
        }

      })
    );

    if (typeof (this.inlineEdit) != "undefined" && (this.inlineEdit == true)) {
      this.gridSection = null;
      this.inEditMode = false;
    }

  }

  checkEditRight() {
    return false;
  }

  loadAdditionalFields(listOfAdditionalData) {

    // execute only if ShowCustomAdditionalDataFields true
    if (this.showCustomAdditionalDataFields == true) {
      if (listOfAdditionalData != null && typeof listOfAdditionalData != "undefined") {
        let requestModel: RequestModel = new RequestModel();

        let entityId = 0;

        if (this.model !== null && typeof this.model !== undefined
          && this.model.Id !== null
          && this.model.Id > 0) {
          entityId = this.model.Id;
        }

        if (this.customApiAdditionalDataFields) {
          requestModel.url = this.customApiAdditionalDataFields;
        } else {
          requestModel.url = "/api/dynamicforms/additionaldatafields";
        }

        if (entityId > 0) {
          requestModel.url += "?id=" + entityId;
        }

        requestModel.contentType = "application/json"
        requestModel.responseType = "application/json"


        try {
          requestModel.data = JSON.stringify(listOfAdditionalData);
        } catch {
          requestModel.data = null;
        }

        this.restProviderService.getDataPOST<any>(requestModel).subscribe(data => {
          this.zone.run(() => {
            if (data != null && typeof data != "undefined" && data.length > 0) {
              this.additionalFields = data;

              // remove properties from model that don't exists in additionalfields anymore
              if (this.model[this.propertyNameAdditionalData] != null && typeof this.model[this.propertyNameAdditionalData] != "undefined") {
                if (this.additionalFields != null && typeof this.additionalFields != "undefined") {

                  for (let propertyBinding in this.model[this.propertyNameAdditionalData]) {

                    let index = this.additionalFields.findIndex(x => x.Binding == propertyBinding);
                    // if property doesnt exists in additionalFields then it was removed from additionalfields and we should also remove from this.model
                    // if not found
                    if (index < 0) {
                      delete this.model[this.propertyNameAdditionalData][propertyBinding];
                    }
                  }
                }
              }
            }
          });
        },
          error => {
          }
        );
      }
    }

  }

  fireSectionAddedEvent() {
    this.utility.newSectionAdded.next(this.model);
  }

  resolvePropertyBinding(object, propertyPath) {

    if (typeof propertyPath != "undefined" && propertyPath != null) {
      let split = propertyPath.split(".");
      let obj = object;

      for (let i = 0; i < split.length; i++) {
        if (obj != null && typeof obj != "undefined") {
          obj = obj[split[i]];
        }
      }

      if (obj != null && typeof obj != "undefined" && obj instanceof Array) {

        if (this.jsFilter && this.jsFilter.length > 0) {
          obj = obj.filter(this.parsedFilterPredicate);
        }

        try {
          if (this.orderEnabled) {
            obj = obj.sort((a, b) => a.Order - b.Order);
          }else{
            obj = obj.sort((a, b) => a.Id - b.Id);
          }
        } catch (e) { }

        if (obj.length > 0 && this.inlineEdit == false) {
          if (!this.hideSectionWhenNotEditing) {
            this.gridSection = obj[obj.length - 1];
            this.inEditMode = true;
          }
        }

        if (typeof this.forwardEntity != "undefined" && this.forwardEntity) {
          obj.forEach(element => {
            element[this.forwardEntity] = _.cloneDeep(this.model[this.forwardEntity]);
          });
        }

        if (this.forwardEntities) {
          this.forwardEntities.forEach(element => {
            var el = _.cloneDeep(this.dfms.getValue(this.model, element));

            if (el) {
              obj.forEach(ele => {
                this.dfms.assign(ele, element, el, true);
              });
            }

          });
        }


        return obj;
      }
    }



    return [];
  }

  modelChanged($event) {
    //console.log("one2m changed model");
  }

  findParentInstance<T>(injector: Injector, token: any): T | null {
    let parentInjector = injector;
    while (parentInjector) {
      const instance = parentInjector.get<T>(token, null);
      if (instance) {
        return instance; // return the first instance found
      }
      parentInjector = parentInjector['parent'];
    }
    return null;
  }

  async getContentTemplate() {

    /*

    let templateUrl = "";

    for (var i = 0; i < this.dynamicRoutesLoader.wgRoutes.length; i++) {
      if (this.dynamicRoutesLoader.wgRoutes[i]["PrettyUrl"] == window.location.pathname.substring(1)) {
        templateUrl = this.dynamicRoutesLoader.wgRoutes[i].Url;
        break;
      }
    }

    this.restProviderService.getDataGET(templateUrl).subscribe(async rawTemplate => {
      //console.log("Retrieved dynamic template: ", rawTemplate);
      let startParseIndex = rawTemplate.indexOf("<ng-container class=\"" + this.bindingPropertyName) + this.bindingPropertyName.length+23;
      let endParseIndex = rawTemplate.indexOf("</ng-container>",startParseIndex);
      let contentLength = endParseIndex - startParseIndex;


      this.contentTemplate = rawTemplate.substring(startParseIndex, endParseIndex);

      this.restProviderService.modelValueChanged.subscribe(model => {

        let toAssign = this.dfms.getValue(model, this.bindingPropertyName);
        if (typeof toAssign != "undefined") {
          this.currentNumber = toAssign.length;
          for (var i = 0; i < toAssign.length; i++) {
            toAssign[i]["SerializationObjectFormLink"] = this.model["SerializationObjectFormLink"];
          }
        }
  
      });

    });*/
    /*
        if(this.dynamicRoutesLoader.wgRoutes.length == 0){
          await this.dynamicRoutesLoader.loadConfig(window.location.pathname.substring(1));
        }*/

    let semDynamicControlParent = this.injector.get(SemDynamicControlComponent, null); // Find parent instance
    let veryFirstSemDynamicControlParent = this.findParentInstance<SemDynamicControlComponent>(this.injector, SemDynamicControlComponent);

    let dynamicFormUrl = window.location.pathname.substring(1);

    if (semDynamicControlParent) {
      if (semDynamicControlParent.url) {
        dynamicFormUrl = semDynamicControlParent.url;
        this.nestedRenderUrl = dynamicFormUrl;
      }
    }

    if (this.nestedRenderUrl && this.nestedRenderUrl.length > 0) {
      dynamicFormUrl = this.nestedRenderUrl;
    }

    let templateUrl = dynamicFormUrl;

    for (var i = 0; i < this.dynamicRoutesLoader.wgRoutes.length; i++) {
      if (this.dynamicRoutesLoader.wgRoutes[i]["PrettyUrl"] == templateUrl) {
        templateUrl = this.dynamicRoutesLoader.wgRoutes[i].Url;
        break;
      }
    }

    for (var i = 0; i < this.dynamicRoutesLoader.loadedRoutes.length; i++) {
      if (this.dynamicRoutesLoader.loadedRoutes[i].Url == templateUrl) {
        this.templateProvided = true;
        this.loadContent(this.dynamicRoutesLoader.loadedRoutes[i].Html);
        break;
      }
    }

    if (!this.templateProvided) {
      this.restProviderService.getDataGET(templateUrl).subscribe(async rawTemplate => {
        //console.log("Retrieved dynamic template: ", rawTemplate);
        this.loadContent(rawTemplate);

      });
    }
  }

  loadContent(rawTemplate) {
    const startMarker = "<ng-container class=\"" + this.bindingPropertyName + this.uniqueIdentifier;
    const startMarkerIdx = rawTemplate.indexOf(startMarker);
    let startParseIndex = startMarkerIdx + this.bindingPropertyName.length + this.uniqueIdentifier.length + 23;
    //let endParseIndex = rawTemplate.indexOf("</ng-container><!--" + this.bindingPropertyName + "-->", startParseIndex);
    //</ng-container></div><span class=\""+ThisSettings.BindingPropertyName + "\"></span>
    let endParseIndex = rawTemplate.indexOf("</ng-container></div><span class=\"" + this.bindingPropertyName + this.uniqueIdentifier + "\"></span>", startParseIndex);
    let contentLength = endParseIndex - startParseIndex;

    // Guard: if markers not found, don't set contentTemplate (avoids compiling garbage)
    if (startMarkerIdx === -1 || endParseIndex === -1 || contentLength <= 0) {
      console.warn('[O2M loadContent] markers not found for:', this.bindingPropertyName, 'unique:', this.uniqueIdentifier,
        'startFound:', startMarkerIdx !== -1, 'endFound:', endParseIndex !== -1);
      // Don't set contentTemplate — leave it null so the O2M won't try to compile a broken template
    } else {
      this.contentTemplate = rawTemplate.substring(startParseIndex, endParseIndex);
    }
    this.changeDetection.detectChanges();

    this.subscriptions.push(
      this.restProviderService.modelValueChanged.subscribe(model => {
        if (typeof this.model != "undefined" && this.model) {
          let forwardEnt = this.model[this.forwardEntity];
          if (typeof forwardEnt != "undefined" && forwardEnt) {
            if (typeof this.model[this.bindingPropertyName] != "undefined") {
              for (var i = 0; i < this.model[this.bindingPropertyName].length; i++) {
                this.model[this.bindingPropertyName][i][this.forwardEntity] = forwardEnt;
              }
            }
          }

          if (this.forwardEntities) {
            if (typeof this.model[this.bindingPropertyName] != "undefined") {
              for (var i = 0; i < this.model[this.bindingPropertyName].length; i++) {
                this.forwardEntities.forEach(element => {
                  this.model[this.bindingPropertyName][i][element] = this.model[element];
                });
              }
            }
          }
        }
      })
    );
  }

  isAddAvailable(): boolean {
    if (typeof this.jsAddCondition !== "undefined" && this.jsAddCondition && this.jsAddCondition.length > 0) {
      try {
        return new Function('model', 'return ' + this.jsAddCondition)(this.model);
      } catch (error) {
        //console.error("Error evaluating condition:", error);
        return false; // Fail-safe return value
      }
    }

    return true;
  }



  addSection() {

    if (this.editInDialog) {
      this.addSectionInDialog();
      return;
    }

    try {
      this.dfms.globalForm.form.markAsDirty();
    } catch (e) {

    }

    /*if(typeof this.showAsListing != "undefined" && this.showAsListing && !this.gridSection){
      this.gridSection = {};
      this.changeDetection.detectChanges();
    }*/

    let toAssign = this.dfms.getValue(this.model, this.bindingPropertyName);
    if ((typeof this.showAsListing != "undefined" && this.showAsListing && this.gridSection) || (typeof this.inlineEdit != "undefined" && this.inlineEdit)) {

      if (this.inEditMode) {
        this.inEditMode = false;
      }

      if (typeof toAssign == "undefined" || toAssign == null) {
        toAssign = [];
      }

      if (!(Array.isArray(toAssign))) {
        toAssign = [toAssign];
      }

      let objToAdd = {};

      if (typeof this.forwardEntity != "undefined" && this.forwardEntity) {
        objToAdd[this.forwardEntity] = _.cloneDeep(this.model[this.forwardEntity]);
      }

      if (this.forwardEntities) {
        this.forwardEntities.forEach(element => {
          objToAdd[element] = _.cloneDeep(this.model[element]);
        });
      }

      toAssign.push(objToAdd);

      //this.gridSection = toAssign[toAssign.length - 1];

      /*this.gridSection = null;
      this.changeDetection.detectChanges();
      this.gridSection = {};*/


      //this.gridSection = toAssign[toAssign.length - 1];

      this.dfms.assign(this.model, this.bindingPropertyName, toAssign, true);

      //this.changeDetection.detectChanges();
      this.currentNumber = toAssign.length;
      this.inEditSection(toAssign.length - 1);


    } else {

      if (typeof toAssign == "undefined" || toAssign == null) {
        toAssign = [];
      }

      if (!(Array.isArray(toAssign))) {
        toAssign = [toAssign];
      }


      if (this.maxCount == -1 || toAssign.length < this.maxCount) {
        let objToAdd = {};

        if (typeof this.forwardEntity != "undefined" && this.forwardEntity) {
          objToAdd[this.forwardEntity] = _.cloneDeep(this.model[this.forwardEntity]);
        }

        if (this.forwardEntities) {
          this.forwardEntities.forEach(element => {
            objToAdd[element] = _.cloneDeep(this.model[element]);
          });
        }

        //objToAdd["SerializationObjectFormLink"] = this.model["SerializationObjectFormLink"];
        toAssign.push(objToAdd);

        this.dfms.assign(this.model, this.bindingPropertyName, toAssign);
        this.currentNumber = toAssign.length;

        if (typeof this.showAsListing != "undefined" && this.showAsListing) {
          this.gridSection = objToAdd;
        }
      }
    }


    // if PostAddNewClientLogic exists execute
    if (this.postAddNewSectionLogic != null && typeof this.postAddNewSectionLogic != "undefined") {
      let preResult = function (str) {
        return eval(str);
      }.call(this, this.postAddNewSectionLogic);
    }
  }

  get items() {
    return this.dfms.getValue(this.model, this.bindingPropertyName);
  }

  reorder(item: any) {
    var _items = this.items;
    const currentIndex = _items.findIndex((i) => i.Id === item.section.Id);

    if (item.direction === 'up' && currentIndex > 0) {
      const target = _items[currentIndex - 1];
      this.swapOrders(item, target);
    } else if (item.direction === 'down' && currentIndex < _items.length - 1) {
      const target = _items[currentIndex + 1];
      this.swapOrders(item, target);
    }

    // Re-sort the array to maintain order
    this.sortItems(_items);
    this.normalizeOrders(_items);
  }

  swapOrders(item1: any, item2: any) {
    [item1.section.Order, item2.Order] = [item2.Order, item1.section.Order];
  }

  sortItems(p_items) {
    p_items.sort((a, b) => a.Order - b.Order);
  }

  isFirst(item: any): boolean {
    return this.items.findIndex((i) => i.Id === item.section.section.Id) === 0;
  }

  isLast(item: any): boolean {
    return this.items.findIndex((i) => i.Id === item.section.section.Id) === this.items.length - 1;
  }
  normalizeOrders(p_items) {
    // Reassign Order values sequentially based on current order
    p_items.sort((a, b) => a.Order - b.Order).forEach((item, index) => {
      item.Order = index + 1;
    });

    this.dfms.assign(this.model, this.bindingPropertyName, p_items);
  }

  removeSection(section: any) {

    this.dfms.globalForm.form.markAsDirty();

    const dialogRef = this.dialog.open(SemConfirmDialogComponent, { data: { type: DialogType.Confirmation, text: 'WebGalis_NavigateAway' } });
    dialogRef.afterClosed().subscribe(result => {

      if (result) {
        let values = this.dfms.getValue(this.model, this.bindingPropertyName);
        for (var i = 0; i < values.length; i++) {
          if (values[i] == section) {
            values.splice(i, 1);
            this.currentNumber = values.length;
            if (this.hideSectionWhenNotEditing) {
              this.gridSection = null;
            }
            break;
          }
        }

        this.fireSectionAddedEvent();
        // execute JS logic after section is removed	
        this.executeAfterRemoveSectionLogic();
      }

    });

  }

  executeAfterRemoveSectionLogic() {
    if (this.afterRemoveSectionLogicEvent != null && typeof this.afterRemoveSectionLogicEvent != "undefined"
      && this.afterRemoveSectionLogicEvent.length > 0) {
      eval(this.afterRemoveSectionLogicEvent);
    }
  }

  /**
   * Add flow for EditInDialog: create the item, append it and open it in the dialog.
   * Mirrors addSection(), except that the new item never becomes the inline gridSection
   * and it is dropped again if the user cancels the dialog.
   */
  addSectionInDialog() {

    let toAssign = this.dfms.getValue(this.model, this.bindingPropertyName);

    if (typeof toAssign == "undefined" || toAssign == null) {
      toAssign = [];
    }

    if (!(Array.isArray(toAssign))) {
      toAssign = [toAssign];
    }

    if (this.maxCount != -1 && toAssign.length >= this.maxCount) {
      return;
    }

    let objToAdd = {};

    if (typeof this.forwardEntity != "undefined" && this.forwardEntity) {
      objToAdd[this.forwardEntity] = _.cloneDeep(this.model[this.forwardEntity]);
    }

    if (this.forwardEntities) {
      this.forwardEntities.forEach(element => {
        objToAdd[element] = _.cloneDeep(this.model[element]);
      });
    }

    toAssign.push(objToAdd);

    this.dfms.assign(this.model, this.bindingPropertyName, toAssign);
    this.currentNumber = toAssign.length;

    // same place in the flow as in the inline mode - the logic runs on add, not on confirm
    if (this.postAddNewSectionLogic != null && typeof this.postAddNewSectionLogic != "undefined") {
      let preResult = function (str) {
        return eval(str);
      }.call(this, this.postAddNewSectionLogic);
    }

    this.openSectionDialog(toAssign.length - 1, true);
  }

  /**
   * Opens one section in a modal dialog.
   *
   * The dialog edits the array item in place, exactly as the inline section does, so
   * cancelling has to undo the edits here: a brand new item is dropped, an existing one
   * is restored from the snapshot taken before the dialog was opened.
   */
  openSectionDialog(index: number, isNew: boolean) {

    let items = this.dfms.getValue(this.model, this.bindingPropertyName);

    if (items == null || typeof items == "undefined" || !Array.isArray(items) || items[index] == null) {
      return;
    }

    let section = items[index];
    let snapshot = _.cloneDeep(section);

    // the dialog replaces the inline editing area entirely
    this.gridSection = null;
    this.inEditMode = false;
    this.selectedIndex = index;

    const dialogRef = this.dialog.open(SemO2mSectionDialogComponent, {
      panelClass: 'o2m-section-dialog-panel',
      data: {
        title: isNew
          ? (this.addNewTranslation ? this.addNewTranslation : "AddNew")
          : (this.containerTitle ? this.containerTitle : this.bindingPropertyName),
        section: section,
        contentTemplate: this.contentTemplate,
        bindingPropertyName: this.bindingPropertyName,
        parentBindingProp: this.parentBindingProp,
        forwardEntity: this.forwardEntity,
        forwardEntities: this.forwardEntities,
        actions: this.actions,
        hideRepeaterActionsCondition: this.hideRepeaterActionsCondition,
        orderProperty: this.orderProperty,
        listingFields: this.listingFields,
        number: index + 1
      }
    });

    dialogRef.afterClosed().subscribe(confirmed => {

      if (confirmed) {
        try {
          this.dfms.globalForm.form.markAsDirty();
        } catch (e) {
        }
      } else if (isNew) {
        this.discardSection(section);
      } else {
        this.restoreSection(section, snapshot);
      }

      this.fireSectionAddedEvent();
      this.changeDetection.detectChanges();
    });
  }

  /**
   * Removes a section without asking for confirmation - used when a freshly added
   * section is cancelled, where there is nothing yet to confirm losing.
   */
  private discardSection(section: any) {
    let items = this.dfms.getValue(this.model, this.bindingPropertyName);

    if (items == null || !Array.isArray(items)) {
      return;
    }

    for (var i = 0; i < items.length; i++) {
      if (items[i] === section) {
        items.splice(i, 1);
        break;
      }
    }

    this.dfms.assign(this.model, this.bindingPropertyName, items);
    this.currentNumber = items.length;
    this.executeAfterRemoveSectionLogic();
  }

  /**
   * Rolls the section back to the snapshot. The object identity has to survive, because
   * the array item is what the parent model holds - so properties are reset on the very
   * same object instead of replacing it.
   */
  private restoreSection(section: any, snapshot: any) {
    Object.keys(section).forEach(key => {
      if (!(key in snapshot)) {
        delete section[key];
      }
    });

    Object.keys(snapshot).forEach(key => {
      section[key] = snapshot[key];
    });
  }

  /**
   * index   = index of the row in the DISPLAYED list (template $index) - used for selectedIndex / edit-panel placement.
   * section = the row object itself. When jsFilter is set the displayed list is a filtered copy, so the displayed
   *           index is NOT a valid index into the raw model list; the object is. Internal callers that only know
   *           a raw index (add new -> edit last) keep passing the index alone.
   */
  inEditSection(index, section = null) {
    if (this.editInDialog) {
      // section (displayed row object) wins over the displayed index when jsFilter filters the list
      let rawIndex = index;
      if (section != null) {
        const rawItems = this.dfms.getValue(this.model, this.bindingPropertyName);
        if (Array.isArray(rawItems) && rawItems.indexOf(section) >= 0) {
          rawIndex = rawItems.indexOf(section);
        }
      }
      this.openSectionDialog(rawIndex, false);
      return;
    }

    if (this.inEditMode && this.selectedIndex == index) {
      this.inEditMode = false;
    } else {
      this.inEditMode = false;
      let toAssign = this.dfms.getValue(this.model, this.bindingPropertyName);
      this.gridSection = null;
      this.changeDetection.detectChanges();
      this.gridSection = section != null ? section : toAssign[index];
      this.selectedIndex = index;
      this.inEditMode = true;
      this.changeDetection.detectChanges();
    }
  }

  /** index / section: see inEditSection. The row is removed from the raw list by object identity when known. */
  inRemoveSection(index, section = null) {

    const dialogRef = this.dialog.open(SemConfirmDialogComponent, { data: { type: DialogType.Confirmation, text: 'WebGalis_NavigateAway' } });
    dialogRef.afterClosed().subscribe(result => {

      if (result) {

        var actionEval = false;
        let toAssign = [];
        toAssign = this.dfms.getValue(this.model, this.bindingPropertyName);

        // translate the displayed index into the raw index (identical unless jsFilter is active);
        // done before the overrideActions eval below so existing override bodies that use `index` get the raw one
        if (section != null && toAssign) {
          const rawIndex = toAssign.indexOf(section);
          if (rawIndex >= 0) {
            index = rawIndex;
          }
        }

        if (typeof this.overrideActions != "undefined" && this.overrideActions) {
          if (this.overrideActions.length > 0) {
            for (var i = 0; i < this.overrideActions.length; i++) {
              if (this.overrideActions[i]["Type"] == 1) {
                //var evalVal = eval("function doIt(toAssign){" + this.overrideActions[i]["ActionBody"] + "} doIt(toAssign);");
                eval(this.overrideActions[i]["ActionBody"]);
                actionEval = true;
                break;
              }
            }
          }
        }

        if (!actionEval) {
          toAssign.splice(index, 1);
        }

        this.dfms.assign(this.model, this.bindingPropertyName, toAssign);

        this.gridSection = null;
        /*this.changeDetection.detectChanges();
        this.gridSection = {};*/
        this.changeDetection.detectChanges();

        this.fireSectionAddedEvent();
      }

    });
  }

  getProp(model, path) {
    if (model[this.propertyNameAdditionalData] != null && typeof model[this.propertyNameAdditionalData] != "undefined") {
      let val = model[this.propertyNameAdditionalData][path];
      return val;
    }
    return null;
  }

  setProp(path, value) {
    if (this.model[this.propertyNameAdditionalData] == null || typeof this.model[this.propertyNameAdditionalData] == "undefined") {
      this.model[this.propertyNameAdditionalData] = {};
    }
    this.model[this.propertyNameAdditionalData][path] = value;
  }

  showAddNew() {
    //  *ngIf="hideNewAddSection == false && !hideOneToManyItems && !checkForDisabled(bindingPropertyName) && dfms?.isFormReadOnly != true"

    if (this.hideNewAddSection == false && !this.hideOneToManyItems && this.dfms?.isFormReadOnly != true) {

      // Mirror the server's ModelWrite gate: a user without the write right (e.g. the
      // Reader group) must not get an add affordance even if the form somehow leaves
      // readonly mode - the save would be refused server-side anyway.
      try {
        const userService = this.injector.get(UserService);
        if (userService && typeof userService.hasRight === "function" && !userService.hasRight("ModelWrite")) {
          return false;
        }
      } catch { }

      if (this.hideNewAddSectionCondition != null && typeof this.hideNewAddSectionCondition != "undefined" && this.hideNewAddSectionCondition.length > 0) {
        var evalResponse = eval(this.hideNewAddSectionCondition);
        if (evalResponse == true) {
          return false;
        }
        return true;
      }
      return true;
    }
    return false;
  }

  showRepeaterActions() {
    if (this.hideRepeaterActionsCondition != null && typeof this.hideRepeaterActionsCondition != "undefined" && this.hideRepeaterActionsCondition.length > 0) {
      var evalResponse = eval(this.hideRepeaterActionsCondition);
      if (evalResponse == true) {
        return false;
      }
      return true;
    }
    return true;
  }

  additionalFieldVisibility(currentAdditionalField) {
    if (this.additionalFieldHideCondition != null) {

      // create function based on what user wrote in control settings (additionalFieldHideCondition)
      // we will also send some parameters into function
      // model => this.model -> this is global model on the form
      // adField => current additional field that we are checking
      // adFieldsHiding => for description go check definition of property
      // if user defines hideCondition (additionalFieldHideCondition) in control settings it must set values true/false to property "adFieldsHiding" in his code - only way fields will be hidden
      var func = Function("adField", "adFieldsHiding", "model", this.additionalFieldHideCondition);

      // call function      
      func(currentAdditionalField, this.additionalFieldsHiding, this.model);

    } else {
      this.additionalFieldsHiding[currentAdditionalField.Binding] = true;
    }

    // functions saves true or false into this object, based on value additional field is then shown/hidden    
    return this.additionalFieldsHiding[currentAdditionalField.Binding];
  }

  searchPageRedirect(section, lf) {

    if (environment.useInlineSearch && environment.useInlineSearch === true) {
      let value = this.dfms.getValue(section, lf.Binding);

      if (value) {
        value = value.toLocaleString('sl-SI');
      }

      //window.location.href = "cms/galisweb/search?view=1&search=" + value + "*";
      this.searchService.splitSearchEnabled = true;

      let bindingProp = this.bindingPropertyName + "." + lf.Binding;


      let e = this.searchService.splitSearchKeywords.filter(i => i.bindingProperty == bindingProp);

      if (e.length > 0) {
        e[0].value = value;
      } else {
        this.searchService.splitSearchKeywords.push({ value: value, bindingProperty: bindingProp, name: this.translationsService.translate(lf.Name) });
      }

      this.searchService.splitSearchS.next(undefined);
    }
  }

  // StringLink listing field: turn the raw cell value into an href. Values without a scheme
  // (e.g. "www.example.com") get "https://" so the browser does not resolve them relative to the app.
  getLinkHref(value: any): string {
    if (value === null || typeof value === "undefined") {
      return "";
    }
    let url = value.toString().trim();
    if (url.length == 0) {
      return "";
    }
    if (/^[a-z][a-z0-9+.-]*:/i.test(url) || url.startsWith("/")) {
      return url;
    }
    return "https://" + url;
  }

  // EnableClickOnRow: only saved rows (with Id) can be opened - a new, unsaved row has nothing to redirect to
  isRowClickable(section: any): boolean {
    return this.enableClickOnRow == true
      && typeof this.enableClickOnRowRedirectUrl == "string" && this.enableClickOnRowRedirectUrl.length > 0
      && section != null && typeof section != "undefined"
      && section.Id != null && typeof section.Id != "undefined" && section.Id > 0;
  }

  // Inline edit row click: opens enableClickOnRowRedirectUrl with the row Id appended in a new browser tab.
  // Clicks on the row's own controls (edit / delete / custom actions, links) keep their behaviour and do not redirect.
  onRowClick(event: MouseEvent, section: any) {
    if (!this.isRowClickable(section)) {
      return;
    }
    const target = event.target as HTMLElement;
    if (target && target.closest && target.closest("a, button, .dd-section, .o2m-row-actions")) {
      return;
    }
    window.open(this.enableClickOnRowRedirectUrl + encodeURIComponent(section.Id), '_blank', 'noopener');
  }

  checkValueTypeForDecimal(value: any) {
    try {
      if (value && value.length > 0) {
        if (!isNaN(value)) {
          return value.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ".");
        } else {
          return value;
        }
      }
      return value;
    } catch (e) {
      console.log(e);
      return value;
    }
  }

}
